export const alphanumericSort = <T extends Record<string, any>>(arr: T[], prop: keyof T): T[] => {
  const sortedArr = [...arr]; // Create a copy of the original array
  sortedArr.sort((a, b) => {
    const valueA = a[prop]?.toString().toLowerCase();
    const valueB = b[prop]?.toString().toLowerCase();
    return valueA?.localeCompare(valueB, undefined, { numeric: true, sensitivity: 'base' }) || 0;
  });
  return sortedArr;
};

export const alphanumericSortStrings = (arr: string[]): string[] => {
  const sortedArr = [...arr];
  sortedArr.sort((a, b) => {
    const valueA = a.toLowerCase();
    const valueB = b.toLowerCase();
    return valueA.localeCompare(valueB, undefined, { numeric: true, sensitivity: 'base' });
  });
  return sortedArr;
};
